import { PetType } from 'constants/pet-type';
import {
  AgeSegmentationIds,
  AllAllergySegmentationIds,
  BreedSegmentationIds,
  CatNutritionSegmentationIds,
  NutritionSegmentationIds,
  ProteinTagValues,
  SegmentationIds,
} from 'constants/segmentation';
import { InputProductType, WetFoodTagValues } from 'interfaces/api-input/input-product-type';

export type ActivityLevel = 'low' | 'medium' | 'high';

export enum BodyCondition {
  VeryLean = 1,
  SlightlyLean = 2,
  Ideal = 3,
  SlightlyRounded = 4,
  WellPadded = 5,
}

// TODO: this type might be wrong. For example selectedNeeds by default is empty array, hence it never be undefined
/** Base interface for common properties between dog and cat profiles */
export interface BasePetProfile {
  id: string;
  petType: PetType;
  selectedAge: AgeSegmentationIds | undefined;
  selectedNeeds: Array<NutritionSegmentationIds | CatNutritionSegmentationIds> | undefined;
  selectedAllergies: Array<AllAllergySegmentationIds> | undefined;
  selectedFoodTypes: Array<InputProductType> | undefined;
  lastTouched: SegmentationIds | undefined;
  updatedAt: string | undefined;
  selectedWeight: number | undefined;
  name: string | undefined;

  // calorie calculator specific
  dateOfBirth: string | undefined;
  bodyCondition: BodyCondition | undefined;
  neutered: boolean | undefined;
  activityLevel: ActivityLevel | undefined;
  kcalUpdatedAt: string | undefined;
  dailyKcal: number | undefined;
  hasSpecialNeeds: boolean | undefined;
}

/** Dog-specific profile interface */
export interface DogProfile extends BasePetProfile {
  petType: typeof PetType.Dog;
  selectedBreed?: BreedSegmentationIds;
}

/** Cat-specific profile interface */
export interface CatProfile extends BasePetProfile {
  petType: typeof PetType.Cat;
  selectedWetFoodTypes: WetFoodTagValues[];
  selectedTastePreferences: ProteinTagValues[];
  selectedDislikedProteins: ProteinTagValues[];
}

/** Type guard to check if profile is a dog profile */
export function isDogProfile(profile: Pick<PetProfile, 'petType'>): profile is DogProfile {
  return profile.petType === PetType.Dog;
}

/** Type guard to check if profile is a cat profile */
export function isCatProfile(profile: Pick<PetProfile, 'petType'>): profile is CatProfile {
  return profile.petType === PetType.Cat;
}

export type PetProfile = DogProfile | CatProfile;
